/** Whether an address fragment carries a TV screen token (`#t=…`): the wall is then a kiosk, without session. */
export const isKiosk = (hash: string): boolean => new URLSearchParams(hash.replace(/^#/, '')).has('t')

/** The link a TV opens: the token in the fragment, never sent to a server. */
export const screenLink = (origin: string, token: string): string => `${origin}/wall#t=${token}`

/** The supervisor's preview of the wall, for a campaign or the whole floor (React's `campagne` query name). */
export const previewPath = (campaignId: string): string =>
  `/wall${campaignId ? `?campagne=${campaignId}` : ''}`
